import styled from 'styled-components'

export const StyledMobileMenuUtility = styled.ul`
  width: auto;
  padding: ${props => props.theme.typography.pxToRem(35)} ${props => props.theme.typography.pxToRem(29)};
  list-style-type: none;
  margin: ${props => props.theme.typography.pxToRem(32)};
  background-color: ${props => props.theme.custom.colors.lightSecondary};
  border-radius: ${props => props.theme.typography.pxToRem(12)};

  li {
    background-color: ${props => props.theme.custom.colors.lightSecondary};
    padding-left: 0;
  }

  a {
      text-decoration: none;
  }
`